import React, { useCallback, useEffect, useState } from 'react';

import { getUITA } from '../../../../../utils/commonUtils';
import ExpressionModal from '../ExpressionModal';

export const ExpandableComponent = ({ row }) => {
  const { classes } = row;
  const [value, setValue] = useState(row[row.currentKeyTemp]);

  useEffect(() => {
    setValue(row[row.currentKeyTemp]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row[row.currentKeyTemp]]);

  const onUpdateValue = useCallback(
    (param) => {
      const newValue = typeof param === 'function' ? param(value) : param;
      setValue(newValue);
      row.editRow(row.id, row.currentKeyTemp, newValue);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [row]
  );

  const onBlurHandler = ({ target }) => {
    row.editRow(row.id, row.currentKeyTemp, target.value);
  };

  return (
    <div>
      <div className={classes.rootFormulaEditorContainer} ui-ta={getUITA('FormulaEditorContainer')}>
        <ExpressionModal
          height={470}
          onChange={onUpdateValue}
          expression={value}
          onBlurEditor={onBlurHandler}
        />
      </div>
    </div>
  );
};
